// extracted by mini-css-extract-plugin
export default {"options":"AsideElementOptions_options__lddr-"};